import { AbstractConnector } from "@web3-react/abstract-connector"

import { injected, torusConnect, walletConnect, walletLinkConnect } from "./config"

export enum WalletType {
    METAMASK = "METAMASK",
    WALLET_CONNECT = "WALLET_CONNECT",
    WALLETLINK_CONNECT = "WALLETLINK_CONNECT",
    TORUS_CONNECT = "TORUS_CONNECT",
}

export interface WalletInfo {
    type: WalletType
    name: string
    description: string
    connector: AbstractConnector
}

export const METAMASK: WalletInfo = {
    type: WalletType.METAMASK,
    name: "Metamask",
    description: "Easy-to-use browser extension.",
    connector: injected,
}
const WALLET_CONNECT: WalletInfo = {
    type: WalletType.WALLET_CONNECT,
    name: "Wallet Connect",
    description: "Universal integration via qr code",
    connector: walletConnect,
}

const WALLETLINK_CONNECT: WalletInfo = {
    type: WalletType.WALLETLINK_CONNECT,
    name: "Coinbase Wallet",
    description: "",
    connector: walletLinkConnect,
}
const TORUS_CONNECT: WalletInfo = {
    type: WalletType.TORUS_CONNECT,
    name: "Torus Wallet",
    description: "",
    connector: torusConnect,
}

export const SUPPORTED_WALLETS = [METAMASK, WALLET_CONNECT, WALLETLINK_CONNECT, TORUS_CONNECT]

export const MetaMaskConnector = injected

function bsearch(a: number[], target: number) {
    let low = 0
    let high = a.length - 1
    while (low <= high) {
        let mid = Math.floor(low + (high - low) / 2)
        if (a[mid] > target) {
            high = mid - 1
        } else if (a[mid] < target) {
            high = mid + 1
        } else {
            if (a[mid - 1] !== target) {
                return mid
            } else {
                high = mid - 1
            }
        }
    }
    return -1
}
